import React, { Component } from "react";
import { Form, Field } from 'react-final-form';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  UncontrolledTooltip
} from "reactstrap";
import Service from "./services";
import { PaginationTotal } from "../../../commons/controls";
import RFForm from "../../../components/Form/RFForm";
import RFField from "../../../components/Form/RFField";
import filterFactory, { textFilter, selectFilter } from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import Loader from "../../../commons/loader";
import NetworkEmptyState from "../../../commons/networkemptystate";
import Lib from "../../../commons/lib";
import ProgressButton from "../../../commons/ProgressButton";

/**
 * Osztály listázza a cikkcsoportokat.
 * @extends Component
 */
class CikkcsoportLista extends Component {
  /**
   * CikkcsoportLista konstruktor.
   * @param {object} props
   */
  constructor(props) {
    super(props);

    /**
     * @type {object}
     * @property {boolean} modal Új cikkcsoport felviteli modalt vezérlő logikai változó.
     * @property {boolean} modalTorles Cikkcsoport törlését megerősítő modalt vezértlő logikai változó.
     * @property {{statusz: string, nev: string, sajatpath: string, szulopath: string, vancikkcsoportja: boolean, vancikke: boolean}} cikkcsoportJson Cikkcsoportokat tartalmazó tömb.
     */
    this.state = {
      modal: false,
      modalTorles: false,
      modalModosit: false,
      felettesek: [],
      cikkcsoportJson: [],
      cikkcsoportModositObj: [],
      sajatId: null,
      statusz: [],
      statuszOptions: [],
      filterOptions: {},
      tableStatus: 'LOAD',
      saveButtonLoading: false,
      deleteButtonLoading: false,
      modifyButtonLoading: false,
      addButtonLoading: false,
    };

    this.required = value => (value ? undefined : 'Kötelező mező!');
  }

  /** Táblázatadatok frissítése miután felépültek a komponensek. */
  componentDidMount() {
    this.updateTable();
  }

  componentDidUpdate(prevProps) {
    if (this.props.active !== prevProps.active) {
      if (this.props.active) {
        this.updateTable();
      }
    }
  }

  /** Táblázat adatainak frissítése adatbázisból. */
  updateTable = () => {
    this.setState({ tableStatus: 'LOAD' });
    Service.listCikkcsoport((err, res) => {
      if (!err) {
        let filters = {};
        let options = res[0].statusz.map((e) => {
          filters[e.name] = e.caption;

          return <option key={e.name} value={e.name}>{e.caption}</option>;
        });

        this.setState({
          cikkcsoportJson: res[0].list,
          filterOptions: filters,
          statusz: res[0].statusz,
          statuszOptions: options,
          tableStatus: 'TABL'
        });
      } else {
        this.setState({ tableStatus: 'NETW' });
      }
    });
  };

  getCikkCsoport = (id) => {
    return new Promise((resolve, reject) => {
      Service.getCikkcsoport(id, (err, res) => {
        if (!err) {
          this.setState({ cikkcsoportModositObj: res[0] }, () => {
            resolve();
          });
        }else{
          reject(new Error('Hálózati hiba!'));
        }
      });
    });
  }

  /** Új cikkcsoport felviteli modal kapcsolása. */
  toggle = () => {
    this.setState({ modal: !this.state.modal, sajatId: null });
    this._currentEditId = undefined;
    this.renderOptions();
  };

  /** Cikkcsoport módosító modal. */
  toggleModosit = () => {
    if (!this.state.modalModosit) {
      this.renderOptions();
    }
    this.setState({
      modalModosit: !this.state.modalModosit,
      sajatId: this._currentEditId
    });
  };

  /** Meglévő cikkcsoport törlés megerősítés modal kapcsolása. */
  toggleTorles = () => {
    this.setState({modalTorles: !this.state.modalTorles});
  };

  /**
   * Letárolja a módosítani kívánt cikkcsoport id-ját.
   * @param {string} id - Aktuális cikkcsoport id-ja.
   */
  handleEditClick = id => {
    this._currentEditId = id;
    this.getCikkCsoport(id);
    this.toggleModosit();
  };

  /**
   * Letárolja a törölni kívánt cikkcsoport id-ját.
   * @param {string} id - Aktuális cikkcsoport id-ja.
   */
  handleDeleteClick = id => {
    this._currentDeleteId = id;
    this.toggleTorles();
  };

  /**
   * Visszaadja a cikkcsoporthoz tartozó művelet gombokat.
   * @param {string} cell - Cella adatot tartalmazó szöveg.
   * @return {ReactElement} Módosítás, törlés gombokat tartalmazó react objektum.
   */
  iconFormatter = cell => {
    return (
      <div>
        {this.props.globals.hasRole(['CIKK_CSOPORT'], true) && (
          <React.Fragment>
            <Button className="icon-pencil table-action-icon" id={'action-view-' + cell + 'modositas'} onClick={() => this.handleEditClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'modositas'} delay={0}>
              Módosítás
            </UncontrolledTooltip>
            <Button className="icon-trash table-action-icon" id={'action-view-' + cell + 'torles'} onClick={() => this.handleDeleteClick(cell)} />
            <UncontrolledTooltip trigger='hover focus-visible' style={{ float: 'left' }} placement="left" target={'action-view-' + cell + 'torles'} delay={0}>
              Törlés
            </UncontrolledTooltip>
          </React.Fragment>
        )}
      </div>
    );
  };

  /**
   * Visszaadja a cikkcsoporthoz tartozó státus jelvényeket.
   * @param {boolean} cell - Cella adatot tartalmazó szöveg.
   * @return {ReactElement} Státusz jelvényt tartalmazó react objektum.
   */
  statusFormatter = cell => {
    let statusz = this.state.statusz.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  };

  /**
   * Paraméterként kapott cikkcsoport objektum felvétele adatbázisba.
   * @param {SytheticEvent} event
   * @param {object} cikkcsoportObj Cikkcsoport adatokat tartalamzó objektum.
   */
  addCikkcsoport = (e, cikkcsoportObj) => {
    this.setState({ addButtonLoading: true });
    Service.addCikkcsoport(cikkcsoportObj, (err) => {
      if (!err) {
        this.toggle();
        this.updateTable();
        this.props.globals.addSuccess("Cikkcsoport hozzáadva!");
      }
      this.setState({ addButtonLoading: false });
    });
  };

  /**
   * Visszaadja a paraméterben kapott path-oz tartozó cikkcsoport nevét.
   * @return {Array.ReactElement} Cikkcsoport neve.
   */
  renderOptions = () => {
    Service.listEmptyCikkcsoport(this._currentEditId, (err, res) => {
      if (!err) {
        let felettesek = res[0].map(e => (
          <option key={e.id} value={e.id}>
            {e.nev}
          </option>
        ));
        this.setState({ felettesek: felettesek });
      }
    });
  };

  /**
   * Törli az adott cikkcsoportot a paraméterként kapott id alapján.
   * @param {string} id - Cikkcsoport sajatpath attributuma.
   */
  deleteCikkcsoport = id => {
    this.toggleTorles();
    this.setState({ deleteButtonLoading: true });
    Service.deleteCikkcsoport(id, (err) => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess("Cikkcsoport törölve!");
      }
      this.setState({ deleteButtonLoading: false });
    });
  };

  /**
   * Paraméterként kapott fioktelep objektum módosítása adatbázisba.
   * @param {object} cikkcsoportObj Fioktelep adatokat tartalamzó objektum.
   */
  modifyCikkcsoport = (e, cikkcsoportObj) => {
    cikkcsoportObj.id = this._currentEditId;
    this.setState({ saveButtonLoading: true });

    Service.editCikkcsoport(cikkcsoportObj, (err) => {
      if (!err) {
        this.toggleModosit();
        this.updateTable();
        this.props.globals.addSuccess("Cikkcsoport módosítva!");
      }
      this.setState({ saveButtonLoading: false });
    });
  };

  /**
   * React render.
   * @return {ReactElement} Cikkcsoport modul.
   */
  render() {
    const options = {
      sizePerPage: 50,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        {
          text: "5",
          value: 5
        },
        {
          text: "10",
          value: 10
        },
        {
          text: "25",
          value: 25
        }, {
          text: '50',
          value: 50
        }
      ]
    };

    const columns = [
      {
        dataField: "nev",
        text: "Cikkcsoport neve",
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        })
      },
      {
        dataField: "parentnev",
        text: "Felettes cikkcsoport",
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        })
      },
      {
        dataField: "statusz",
        text: "Státusz",
        formatter: this.statusFormatter,
        align: "center",
        filter: selectFilter({
          options: this.state.filterOptions,
          placeholder: 'Összes',
        }),
      },
      {
        dataField: "id",
        text: "Műveletek",
        hidden: !this.props.globals.hasRole(['CIKK_CSOPORT'], true),
        formatter: this.iconFormatter
      },
    ];

    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
          {this.props.globals.hasRole(['CIKK_CSOPORT'], true) && 
            <Button
              className="pull-left table-new-button"
              color="primary"
              onClick={this.toggle}
            >
              Új cikkcsoport
            </Button>
          }
          </div>
        </div>
        {{
          LOAD: (<Loader />),
          NETW: (<NetworkEmptyState
            hasImage
            submitClick={() => this.updateTable()}
          />),
          TABL: (
            <BootstrapTable
              bootstrap4
              keyField="id"
              data={this.state.cikkcsoportJson}
              columns={columns}
              filter={filterFactory()}
              pagination={paginationFactory(Lib.bootstraptableProps)}
            />
          )
        }[this.state.tableStatus]}
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
          backdrop="static"
        >
          <RFForm
            title="Cikkcsoport felvétel"
            onSubmit={this.addCikkcsoport}
            modal
            footer={
              <>
                <ProgressButton loading={this.state.addButtonLoading} className="btn-cursor-pointer" color="primary">
                  Mentés
                </ProgressButton>{" "}
                <Button
                  className="btn-cursor-pointer"
                  type="button"
                  color="secondary"
                  onClick={this.toggle}
                >
                  Mégsem
                </Button>
              </>
            }
          >
            <RFField
              name="nev"
              label="Cikkcsoport neve:"
              required
            />
            <RFField
              name="parent"
              label="Felettes cikkcsoport:"
              type="select"
              defaultSelect={(
                <option value="" disabled>
                  Válassz felettest...
                </option>
              )}
              selectOptions={this.state.felettesek}
            />
            <RFField
              required
              name="statusz"
              label="Státusz: *"
              type="select"
              defaultSelect={(
                <option value="" disabled>
                  Válassz státuszt...
                </option>
              )}
              selectOptions={this.state.statuszOptions}
            />
          </RFForm>
          {/* <Form
            onSubmit={this.addCikkcsoport}
            validate={(values) => {
              const errors = {};
              if (!values.nev)
                errors.nev = "Kötelező mező!";
              if (!values.aktiv)
                errors.aktiv = "Kötelező mező!";
              return errors;
            }}
            render={({ handleSubmit, form, submitting, pristine, values }) => (
              <form onSubmit={handleSubmit}>
                <ModalHeader>Cikkcsoport felvétel</ModalHeader>
                <ModalBody>
                  <Field
                    name="nev"
                    component="input"
                    type="text"
                    // validate={required}
                  >
                    {({ input, meta }) => (
                      <>
                        <label>Cikkcsoport neve:</label>
                        <input {...input} type="text" />
                        {meta.error && meta.touched && <span>{meta.error}</span>}
                      </>
                    )}
                  </Field>
                  <div>
                    <label>Felettes cikkcsoport: </label>
                    <Field
                      name="parent"
                      type="select"
                    >
                      {({ input, meta }) => (
                        <>
                          <select {...input}>
                            <option value="" disabled>
                              Válassz felettest...
                            </option>
                            {this.state.felettesek}
                          </select>
                          {meta.error && meta.touched && <span>{meta.error}</span>}
                        </>
                      )}
                    </Field>
                    <div>
                      <label>Státusz: *</label>
                      <Field
                        name="aktiv"
                      >
                        {({ input, meta }) => (
                          <>
                            <select {...input}>
                              <option value="" disabled>
                                Válassz státuszt...
                              </option>
                              <option>Aktív</option>
                              <option>Inaktív</option>
                            </select>
                            {meta.error && meta.touched && <span>{meta.error}</span>}
                          </>
                        )}
                      </Field>
                    </div>
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Button type="submit" color="primary">Mentés</Button>{" "}
                  <Button type="button" color="secondary" onClick={this.toggle}>
                    Mégsem
                  </Button>
                </ModalFooter>
              </form> */}
        </Modal>
        <Modal
          isOpen={this.state.modalModosit}
          toggle={this.toggleModosit}
          className={this.props.className}
          backdrop="static"
        >
          <RFForm
            modal
            onSubmit={this.modifyCikkcsoport}
            ref="asd"
            title="Cikkcsoport módosítás"
            footer={
              <>
                <ProgressButton loading={this.state.saveButtonLoading} className="btn-cursor-pointer" color="primary">
                  Mentés
                </ProgressButton>{" "}
                <Button
                  className="btn-cursor-pointer"
                  type="button"
                  color="secondary"
                  onClick={this.toggleModosit}
                >
                  Mégsem
                </Button>
              </>
            }
          >
            <RFField
              label="Cikkcsoport neve"
              name="nev"
              value={this.state.cikkcsoportModositObj.nev}
              required
            />
            <RFField
              type="select"
              name="parent"
              label="Felettes cikkcsoport"
              value={this.state.cikkcsoportModositObj.parentid}
              defaultSelect={
                <option value="" disabled>
                  Válassz felettest...
                </option>
              }
              selectOptions={this.state.felettesek}
            />
            <RFField
              type="select"
              name="statusz"
              label="Státusz"
              value={
                this.state.cikkcsoportModositObj.statusz
              }
              defaultSelect={
                <option value="" disabled>
                  Válassz státuszt...
                </option>
              }
              selectOptions={this.state.statuszOptions}
              required
            />
          </RFForm>
        </Modal>
        <Modal
          isOpen={this.state.modalTorles}
          toggle={this.toggleTorles}
          className={this.props.className}
          backdrop="static"
        >
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>Valóban törölni kívánod a kiválasztott tételt?</ModalBody>
          <ModalFooter>
            <ProgressButton
              color="primary"
              onClick={() => this.deleteCikkcsoport(this._currentDeleteId)}
              loading={this.state.deleteButtonLoading}
            >
              OK
            </ProgressButton>
            <Button type="button" color="secondary" onClick={this.toggleTorles}>
              Mégsem
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

CikkcsoportLista.propTypes = {
  globals: PropTypes.object,
  active: PropTypes.bool,
  className: PropTypes.string,
};

export default CikkcsoportLista;
